import styled from 'styled-components';
import {LocalDocumentFileFormat} from "../../../models/local-documents.models";


export const StyledDigitizedDocument = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const DigitizedDocumentTypeBadge = styled.span<{ $type: LocalDocumentFileFormat }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    font-size: 12px;
    font-weight: 700;
    border-radius: 4px;
    padding: 2px 6px;
    flex-shrink: 0;
    letter-spacing: 0.4px;
    text-align: center;

    ${({ $type }) => {
    switch ($type) {
        case 'PDF':
            return `color: #7C3AED; background: #EDE9FE;`;
        case 'DOCX':
            return `color: #2563EB; background: #DBEAFE;`;
        case 'DOC':
            return `color: #1D4ED8; background: #DBEAFE;`;
        case 'TXT':
            return `color: #475569; background: #E2E8F0;`;
        case 'JPEG':
            return `color: #16A34A; background: #DCFCE7;`;
        case 'JPG':
            return `color: #16A34A; background: #DCFCE7;`;
        case 'PNG':
            return `color: #946E0D; background: #FBE9CC;`;
        case 'XLSX':
            return `color: #15803D; background: #DCFCE7;`;
        case 'PPTX':
            return `color: #C2410C; background: #FFEDD5;`;
        case 'ODT':
            return `color: #0369A1; background: #E0F2FE;`;
        default:
            return `color: #475569; background: #E2E8F0;`;
    }
}}
`;

export const StyledDigitizedDocumentFileInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    .name {
        font-size: 14px;
        font-family: 'Roboto', sans-serif;
        color: #1E293B;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .info {
        font-size: 12px;
        color: #94A3B8;
        font-family: 'Roboto', sans-serif;
    }
`;